export default "__VITE_ASSET__BQXsLVZO__"